import type { Code } from 'mdast';
import type { State } from '../state';

export function code(state: State, node: Code): void {
	const nodeType = state.schema.nodes.code_block ?? state.schema.nodes.codeBlock;
	if (!nodeType) {
		// Gracefully degrade: render code value as a plain text paragraph
		state.openNode(state.schema.nodes.paragraph);
		state.addText(node.value);
		state.closeNode();
		return;
	}
	const attrs: Record<string, unknown> = {};
	if (node.lang) {
		attrs.language = node.lang;
	}
	state.addNode(nodeType, attrs, node.value ? [state.schema.text(node.value)] : []);
}
